<template>
    <div>
        <v-container
            fluid
            class="pa-0"
        >
            <v-row class="ml-n2 mr-n2">
                <v-col
                    v-for="(newsCard, index) in this.news"
                    :key="index"
                    class="pl-2 pt-2 pr-2"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                >
                    <news-card
                        :news-id="newsCard.news_id"
                        :conference-id="newsCard.conference_seminar_id"
                        :url="`/${newsCard.thumbnail}`"
                        :title="newsCard.text_header"
                        :date="
                            new Date(newsCard.creation_time).toLocaleDateString(
                                'ru-RU',
                                { day: 'numeric', month: 'long' }
                            )
                        "
                        :is-pinned="
                            newsCard.time_of_pin &&
                            new Date() < new Date(newsCard.time_of_pin)
                        "
                    />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import NewsCard from '@/components/news/NewsCard.vue'
import { useNewsStore } from '@/store/news'

export default {
    name: 'NewsCards',
    components: {
        NewsCard
    },
    data() {
        let news = []
        return {
            news: news
        }
    },
    methods: {
      isNewsDataValid(newsData) {
        if (
          newsData.text_header === null
          || newsData.text_header.length === 0
          || newsData.creation_time === null
        ) {
          return false
        }

        return true
      }
    },
    async mounted() {
        const newsStore = useNewsStore()
        await newsStore.getNews(0, 8)
        this.news = newsStore.allNews

        this.news = this.news.filter((news) => this.isNewsDataValid(news))
    }
}
</script>
